module.exports = __webpack_public_path__ + "img/howtoeuro.824ba830.jpg";